module.exports = __webpack_public_path__ + "img/senias-startseite2.c52ab42c.png";